var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerateText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 20H0V14H6V16H3.52C5.13 18.41 7.88 20 11 20C15.97 20 20 15.97 20 11H22C22 17.08 17.08 22 11 22C7.28 22 3.99 20.15 2 17.33V20Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11C0 4.92 4.92 0 11 0C14.72 0 18.01 1.85 20 4.67V2H22V8H16V6H18.48C16.87 3.59 14.12 2 11 2C6.03 2 2 6.03 2 11H0Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.002 16H13.882L7.72195 9.83997L9.84195 7.71997L16.002 13.88V16Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0016 6.29L6.2916 7C5.9016 7.39 5.9016 8.02 6.3016 8.41L7.0216 9.13L9.1416 7.01L8.4216 6.29C8.1916 6.07 7.8416 6 7.7116 6C7.4516 6 7.2016 6.1 7.0016 6.29Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateText);
export default __webpack_public_path__ + "static/media/generateText.7f00dd1e764c05fe3cee96781144848f.svg";
export { ForwardRef as ReactComponent };